import { ColorContext } from 'App';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';

const DateTime = ({ setData, data, type = 'dateTime', setError }) => {
  //This useEffect handles type changes (Date/Time/DateTime).
  useEffect(() => {
    // When `type` changes: convert available values to the new type,
    // clear fields that are no longer used, and set an error when
    // conversion cannot be completed.
    const newData = { ...data };

    switch (type) {
      case 'dateTime':
        // Neither date nor time can be converted to dateTime
        newData.dateTime = '';
        newData.date = '';
        newData.time = '';
        setData({ ...newData, error: true });
        setError({ message: 'Date/time missing' });

        break;

      case 'date':
        //Only dateTime can be converted to date
        if (data?.dateTime && data.dateTime !== '') {
          const dateOnly = moment(data.dateTime).format('YYYY-MM-DD');
          newData.date = dateOnly;
          newData.time = '';
          newData.dateTime = '';
          setData({ ...newData, error: false });
          setError(null);
        } else {
          newData.date = '';
          newData.time = '';
          newData.dateTime = '';
          setData({ ...newData, error: true });
          setError({ message: 'Date missing' });
        }

        break;

      case 'time':
        //Only dateTime can be converted to time
        if (data?.dateTime && data.dateTime !== '') {
          const timeOnly = moment(data.dateTime).format('HH:mm');
          newData.time = timeOnly;
          newData.date = '';
          newData.dateTime = '';
          setData({ ...newData, error: false });
          setError(null);
        } else {
          newData.date = '';
          newData.time = '';
          newData.dateTime = '';
          setData({ ...newData, error: true });
          setError({ message: 'Time missing' });
        }
        break;

      default:
        newData.date = '';
        newData.time = '';
        newData.dateTime = '';
        setData({ ...newData, error: true });
        setError({ message: 'Missing Value' });
        break;
    }
  }, [type]);

  useEffect(() => {
    // If the parent passed in any existing values, prefer those and
    // format them for the inputs rather than overwriting with defaults.
    const hasDateTime =
      data?.dateTime !== undefined && data?.dateTime !== null && data?.dateTime !== '';
    const hasDate = data?.date !== undefined && data?.date !== null && data?.date !== '';
    const hasTime = data?.time !== undefined && data?.time !== null && data?.time !== '';

    if (hasDateTime || hasDate || hasTime) {
      const newData = {
        dateTime: hasDateTime ? moment(data.dateTime).format('YYYY-MM-DDTHH:mm') : '',
        date: hasDate
          ? moment(data.date).format('YYYY-MM-DD')
          : hasDateTime
            ? moment(data.dateTime).format('YYYY-MM-DD')
            : '',
        time: hasTime
          ? moment(data.time, ['HH:mm', 'HH:mm:ss']).format('HH:mm')
          : hasDateTime
            ? moment(data.dateTime).format('HH:mm')
            : '',
        error: false,
      };

      setData(newData);
      setError(null);
      return;
    }

    // No values provided: initialize empty defaults for the active type.
    setData({
      dateTime: type === 'dateTime' ? '' : '',
      date: type === 'date' ? '' : '',
      time: type === 'time' ? '' : '',
      error: true,
    });
  }, []);

  const updateData = (item) => {
    setData({
      ...data,
      ...item,
      error: verifyData({ ...data, ...item }),
    });
  };
  const theme = useContext(ColorContext);

  const verifyData = (data) => {
    let error = false;
    if (type === 'dateTime' && data.dateTime === '') {
      error = true;
    }
    if (type === 'date' && data.date === '') {
      error = true;
    }
    if (type === 'time' && data.time === '') {
      error = true;
    }
    if (error) {
      setError({ message: 'Date/time missing' });
    } else {
      setError(null);
    }
    return error;
  };

  // useEffect(() => {
  //   setData(storedData)
  // }, [storedData])

  return (
    <div key={type}>
      {type === 'dateTime' && (
        <div
          className="d-flex flex-column p-3 rounded-2 m-2"
          style={{
            background: theme.primary,
          }}
        >
          <p>Date Picker</p>
          <input
            type="datetime-local"
            name="dateTime"
            value={data.dateTime}
            onChange={(e) =>
              updateData({
                dateTime: e.target.value,
              })
            }
            placeholder="Date & Time Picker"
          />
        </div>
      )}
      {type === 'time' && (
        <div
          className="d-flex flex-column p-3 rounded-2 m-2"
          style={{
            background: theme.primary,
          }}
        >
          <p>Time Picker</p>
          <input
            type="time"
            name="time"
            value={data.time}
            onChange={(e) =>
              updateData({
                time: e.target.value,
              })
            }
            placeholder="Time Picker"
          />
        </div>
      )}
      {type === 'date' && (
        <div
          className="d-flex flex-column p-3 rounded-2 m-2"
          style={{
            background: theme.primary,
          }}
        >
          <p>Date Picker</p>
          <input
            type="date"
            name="date"
            value={data.date}
            onChange={(e) =>
              updateData({
                date: e.target.value,
              })
            }
            placeholder="Date Picker"
          />
        </div>
      )}
    </div>
  );
};

export default DateTime;
